import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { installUpdateCheck } from './appUpdate';

// Global guard: unhandled promise rejections (e.g. LiveKit WebSocket Event objects)
// should never crash the page — log them and swallow.
window.addEventListener('unhandledrejection', (evt) => {
  const reason = evt.reason;
  if (reason instanceof Event) {
    // WebSocket/MediaError Event thrown as rejection — silence it, just log
    console.warn('[QVENARI] Unhandled WebRTC/WebSocket event rejection (swallowed):', reason.type || reason);
    evt.preventDefault();
  } else {
    const msg = reason?.message || String(reason ?? 'unknown');
    console.warn('[QVENARI] Unhandled promise rejection (swallowed):', msg, reason);
    evt.preventDefault();
  }
});

class ErrorBoundary extends React.Component<{children:React.ReactNode},{err:Error|null,info:string}> {
  constructor(p:any){super(p);this.state={err:null,info:''};}
  static getDerivedStateFromError(err:Error){return{err};}
  componentDidCatch(err:Error, info:React.ErrorInfo){
    console.error('[QVENARI-CRASH]', err, info.componentStack);
    this.setState({err, info: info.componentStack || ''});
  }
  render(){
    if(this.state.err){
      return(
        <div style={{position:'fixed',inset:0,background:'#1a0505',color:'#ff8080',fontFamily:'monospace',padding:24,overflow:'auto',zIndex:99999}}>
          <div style={{fontSize:18,fontWeight:700,marginBottom:12,color:'#ff4040'}}>React krasch</div>
          <div style={{background:'rgba(255,0,0,0.1)',border:'1px solid #c0392b',borderRadius:4,padding:12,marginBottom:12}}>
            <div style={{fontWeight:700,marginBottom:6}}>{this.state.err.name}: {this.state.err.message}</div>
            <pre style={{fontSize:10,whiteSpace:'pre-wrap',wordBreak:'break-all',color:'#ffaaaa',margin:0}}>{this.state.err.stack}</pre>
          </div>
          {this.state.info && (
            <div style={{background:'rgba(255,100,0,0.1)',border:'1px solid #c06020',borderRadius:4,padding:12,marginBottom:12}}>
              <div style={{fontWeight:700,marginBottom:4,color:'#ffa060'}}>Komponent-stack:</div>
              <pre style={{fontSize:10,whiteSpace:'pre-wrap',color:'#ffcc99',margin:0}}>{this.state.info}</pre>
            </div>
          )}
          <button onClick={()=>this.setState({err:null,info:''})} style={{background:'#c0392b',color:'#fff',border:'none',borderRadius:4,padding:'8px 20px',cursor:'pointer',fontSize:13}}>Ladda om</button>
        </div>
      );
    }
    return this.props.children;
  }
}

// /_ui: intern demosida för components/ui, bara i dev (byggs inte in i prod).
const UiDemo = import.meta.env.DEV && window.location.pathname === '/_ui' ? React.lazy(() => import('./components/ui/UiDemo')) : null;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    {UiDemo ? <React.Suspense fallback={null}><UiDemo /></React.Suspense> : (
      <App />
    )}
  </ErrorBoundary>
);
// Från och med nu visar index.html inte längre sin "JS-krasch (pre-React)"-ruta.
(window as any).__QVENARI_MOUNTED__ = true;
installUpdateCheck();
